import ko from "knockout";
import $ from "jquery";
import "flow/bindings/clickBinding";
import myFlowLocator from "flow/utils/myFlowLocator";
import register from "flow/knockout/register";

register.registerKnockoutBinding("clickIfValidV3", {
    init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
        const newValueAccessor = function () {
            return function () {
                const myFlow = myFlowLocator.getMyFlow(bindingContext.$root);

                if (myFlow.hasOngoingTasks()) {
                    return;
                }

                let param = valueAccessor();

                if (ko.isObservable(param)) {
                    param = ko.unwrap(param);
                }

                let config;

                if (typeof param === "function") {
                    config = {
                        action: param,
                        validatableObject: viewModel
                    };
                } else {
                    config = {
                        action: param.action,
                        validatableObject: param.validatableObject ? param.validatableObject : viewModel
                    };
                }

                const errors = myFlow.getValidationErrorsV3(config.validatableObject);

                if (errors().length === 0) {
                    const vm = bindingContext.$data;
                    config.action.apply(vm, arguments);
                } else {
                    errors.showAllMessages();
                    const formElement = $(element).parents("form").get(0);
                    myFlow.focusFirstErrorV3(formElement);
                    myFlow.logValidationErrorsV3(config.validatableObject);
                }
            };
        };

        return ko.bindingHandlers.click.init(element, newValueAccessor, allBindingsAccessor, viewModel, bindingContext);
    }
});
